// Matches --sidebar-width in index.css; the drag range is anchored to it.
export const SIDEBAR_DEFAULT_WIDTH = 300
export const SIDEBAR_MIN_WIDTH = SIDEBAR_DEFAULT_WIDTH - 50
export const SIDEBAR_MAX_WIDTH = SIDEBAR_DEFAULT_WIDTH + 200

export const clampSidebarWidth = (width: number): number =>
  Math.round(Math.min(SIDEBAR_MAX_WIDTH, Math.max(SIDEBAR_MIN_WIDTH, width)))
